import { useCallback } from 'react';

import { useClearSelectedFilterParams, useGetFilterParams, useSetFilterParams } from 'src/hooks';
import { filterAllPlacementsValue, ListOfDropdown } from 'src/typings/filter';

export const useCheckboxState = (
  nameOfField: string,
) => {
  const { filterParams } = useGetFilterParams();
  const { handleWriteToRedux } = useSetFilterParams();
  const { handleClearFilterParam } = useClearSelectedFilterParams();

  const handleSelectSingleCheckbox = useCallback((value: string) => {
    if (filterParams[nameOfField]?.isDisabled) {
      return;
    }

    if (filterParams && filterParams?.all?.data === filterAllPlacementsValue) {
      handleClearFilterParam(ListOfDropdown.all);
    }

    if (value === filterParams[nameOfField]?.data) {
      handleWriteToRedux(
        nameOfField,
        '',
      );
    } else {
      handleWriteToRedux(
        nameOfField,
        value,
      );
    }
  }, [filterParams, nameOfField, handleWriteToRedux]);

  return {
    filterValue: filterParams[nameOfField]?.data || '',
    handleSelectSingleCheckbox,
  };
};
